import { Component, OnInit } from '@angular/core';
import { NavService } from 'src/app/_services/nav.service';
import { FilesControlService } from 'src/app/_services/files-control.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { Location } from '@angular/common';

@Component({
  selector: 'files-control-detail',
  templateUrl: './files-control-detail.component.html',
  styleUrls: ['./files-control-detail.component.css'],
})
export class FilesControlDetailComponent implements OnInit {
  private readonly companyScopeId = 1075;
  data: { title: 'Reports' };
  isLoading: boolean = true;
  currentTab: number = 1;
  id;
  file;
  isSuperAdmin: boolean;
  private irmFileName: string;
  private isCompany1075 = false;

  // tslint:disable-next-line: max-line-length
  constructor(
    private navService: NavService,
    public filesControlService: FilesControlService,
    public activatedRoute: ActivatedRoute,
    public route: Router,
    public authService: AuthService,
    private location: Location
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    this.isLoading = true;
    this.resolveCompanyScope();
    this.authService.isSuperAdmin().subscribe((res) => {
      this.isSuperAdmin = !!res;
    });
    this.activatedRoute.queryParamMap.subscribe((q) => {
      this.irmFileName = q.get('fileName');
    });
    this.getData();
    this.selectedNavItem({
      parent: 'menu.reports.reports',
      child: 'menu.utilities.fileTraceability',
      description: 'pageDescriptions.filesControl',
    });
    // Min Date
  }

  getData() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.filesControlService
        .getFileInfoById({ id: this.id })
        .subscribe((res) => {
          this.file = res.body;
          this.tryRemapFromIrmFileName();
        });
    });
  }

  private tryRemapFromIrmFileName() {
    if (!this.isCompany1075 || !this.irmFileName || !this.isEmptyFileInfo(this.file)) {
      return;
    }

    const filters = {
      fileName: this.irmFileName,
      sort: ['modificationDate'],
      order: ['desc'],
    };

    this.filesControlService.getAllFiles(0, filters, 50).subscribe((res) => {
      const results = (res?.body?.results || []) as any[];
      const normalizedTarget = this.normalizeFileName(this.irmFileName);
      const matched = results.find((item) => this.normalizeFileName(item?.fileName) === normalizedTarget);

      if (!matched?.id || matched.id === this.id) {
        return;
      }

      this.id = matched.id;
      this.filesControlService.getFileInfoById({ id: this.id }).subscribe((detailRes) => {
        this.file = detailRes.body;
      });
    });
  }

  private normalizeFileName(value: string) {
    return (value || '').toString().trim().toLowerCase();
  }

  private isEmptyFileInfo(file: any) {
    if (!file) {
      return true;
    }

    const fileName = (file.fileName || '').toString().trim();
    const ownerUser = (file.ownerUser || '').toString().trim();
    return fileName.length === 0 || fileName === '-' || ownerUser.length === 0 || ownerUser === '-';
  }

  private resolveCompanyScope() {
    const token = localStorage.getItem('token');
    if (!token) {
      this.isCompany1075 = false;
      return;
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      this.isCompany1075 = Number(payload?.idCompany) === this.companyScopeId;
    } catch {
      this.isCompany1075 = false;
    }
  }

  goBack() {
    this.location.back();
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }
}
